import React from 'react';
import classnames from 'classnames';
import {
  FloatingLabel, Form, FormControl, InputGroup,
} from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FormRenderFieldType } from 'types/TextField';
import { InputFileProps } from 'types/InputFile';

function ImageProfileField( {
  value,
  label,
  placeholder,
  size,
  translateLabel = true,
  validateTranslateValues,
  classNames = {},
  onChange,
  isInvalid,
  showErrors = true,
  appendIcon,
  meta,
  onClickAppendIcon,
  dropzoneOptions,
}: InputFileProps & FormRenderFieldType ) {
  const { t } = useTranslation();

  return (
    <Form.Group className={classnames( 'form-group', classNames.formGroup, {
      'is-invalid': isInvalid,
    } )}
    >
      <Dropzone
        {...dropzoneOptions}
        onDrop={( files ) => {
          if ( files && onChange ) {
            if ( dropzoneOptions?.multiple ) {
              if ( Array.isArray( value ) ) {
                onChange( [...value, ...files] );
              } else onChange( files );
            } else onChange( files[0] );
          }
        }}
      >
        {( { getRootProps, getInputProps } ) => (
          <div className="dropzone" {...getRootProps()}>
            <input {...getInputProps()} />

            <InputGroup>
              {label ? (
                <FloatingLabel
                  label={translateLabel && typeof label === 'string' ? t( label ) : label}
                >
                  <Form.Control
                    value={Array.isArray( value ) ? value.map( ( item ) => item.name ).join( ', ' ) : value?.name || ''}
                    placeholder={placeholder ? t( placeholder ) : ' '}
                    size={size === 'sm' ? 'sm' : undefined}
                    isInvalid={isInvalid}
                    className={classNames.input}
                    readOnly
                    style={{ pointerEvents: 'none' }}
                  />
                </FloatingLabel>
              )
                : (
                  <Form.Control
                    value={Array.isArray( value ) ? value.map( ( item ) => item.name ).join( ', ' ) : value?.name || ''}
                    placeholder={placeholder ? t( placeholder ) : ' '}
                    size={size === 'sm' ? 'sm' : undefined}
                    isInvalid={isInvalid}
                    className={classNames.input}
                    readOnly
                    style={{ pointerEvents: 'none' }}
                  />
                )}

              {appendIcon ? (
                <InputGroup.Text
                  className={classnames( appendIcon, 'cursor-pointer' )}
                  onClick={onClickAppendIcon}
                />
              ) : (
                <InputGroup.Text className="cursor-pointer">
                  Browse
                </InputGroup.Text>
              )}
            </InputGroup>

            {showErrors
            && (
              <FormControl.Feedback type="invalid">
                {isInvalid ? t( meta?.error || meta?.submitError, validateTranslateValues ) || ' ' : ''}
              </FormControl.Feedback>
            )}
          </div>
        )}
      </Dropzone>
    </Form.Group>
  );
}

export default ImageProfileField;
